import axios from 'axios'
import store from '@/store'

export default {
  getTimeOffs () {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/time-offs`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            store.dispatch('timeOffs/setTimeOff', res.data)
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  showTimeOff (id) {
    return new Promise((resolve, reject) => {
      axios
        .get(`/api/time-offs/` + id, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  createTimeOff (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/time-offs/`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  editTimeOff (params) {
    return new Promise((resolve, reject) => {
      axios
        .put(`/api/time-offs/${params.id}`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  validateTimeOff (params) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/time-offs/validate`, params, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  approveTimeOff (id, approved) {
    return new Promise((resolve, reject) => {
      axios
        .post(`/api/time-offs/approve`, { id, approved }, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  },
  removeTimeOff  (id) {
    return new Promise((resolve, reject) => {
      axios
        .delete(`/api/time-offs/${id}`, {
          headers: {
            Authorization: 'Bearer' + localStorage.getItem('access_token')
          }
        })
        .then(
          res => {
            resolve(res)
          },
          error => {
            reject(error)
          }
        )
    })
  }
}
